var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "neta-lists" }, [
    _c(
      "div",
      { staticClass: "list-menu" },
      [
        _c(
          "a-menu",
          {
            style: { background: "transparent" },
            attrs: { mode: "horizontal", align: "center" },
            model: {
              value: _vm.currentList,
              callback: function($$v) {
                _vm.currentList = $$v
              },
              expression: "currentList"
            }
          },
          [
            _c(
              "a-menu-item",
              { key: "neta-bulletin-index" },
              [
                _c("a-icon", { attrs: { type: "read" } }),
                _vm._v("\n        Faliújság\n      ")
              ],
              1
            ),
            _c(
              "a-menu-item",
              { key: "neta-bulletin-documents" },
              [
                _c("a-icon", { attrs: { type: "folder-open" } }),
                _vm._v("\n        Dokumentumok\n      ")
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "list-content" }, [_c("router-view")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }